/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useEffect, useState } from "react";
import { Grid } from "@mantine/core";
import OrganizationCard from "../organizations/OrganizationCard";
import OrganizationSmallCard from "../organizations/OrganizationSmallCard";
import { IconAlertCircle } from "@tabler/icons-react";

export default function SingleOrganizationsDetail({
  dictionary,
  setCount,
  organizationsData,
}) {
  useEffect(() => {
    setCount(organizationsData?.count ?? 0);
  }, []);

  return (
    <>
      <Grid>
        {organizationsData?.data.length == 0 && (
          <div className="my-20 mx-auto text-center">
            <IconAlertCircle size={100} className="mx-auto text-primary" />
            <div className=" text-[30px] font-semibold text-center text-greyDark mx-auto">
              {dictionary.noResultsFound}
            </div>
            <p className="text-textGrey">
              {dictionary.noResultsFoundCheckFilters}
            </p>
          </div>
        )}
        {organizationsData?.data.map((organization, index) => (
          <Grid.Col span={12} md={6} lg={6} p={0} key={organization.id}>
            <div className="hidden lg:block">
              <OrganizationCard
                organization={organization}
                className="m-2"
                dictionary={dictionary}
              />
            </div>
            <div className="block lg:hidden">
              <OrganizationSmallCard
                organization={organization}
                className="m-2"
                dictionary={dictionary}
              />
            </div>
          </Grid.Col>
        ))}
      </Grid>
    </>
  );
}
